export default "__VITE_ASSET__BiFp030C__"